module.exports = __webpack_public_path__ + "static/media/16.d1fe402d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/16.png
// module id = 1346
// module chunks = 0